module.exports = __webpack_public_path__ + "cm.ba51e650d05dc0b064dd.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/cm.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/cm.svg
// module chunks = styles